import { Link } from "gatsby";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import LanguageSelector from "./LanguageSelector";

import shotdokIcon from "../images/shotdok-icon.png";

const NavigationBar = () => {
  const intl = useIntl();

  return (
    <div>
      <div className="relative pt-6 px-4 sm:px-6 lg:px-8">
        <nav
          className="relative flex items-center justify-between sm:h-10 lg:justify-start"
          aria-label="Global"
        >
          <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
            <div className="flex items-center justify-between w-full md:w-auto">
              <Link to={intl.formatMessage({ id: "LINK_HOME_URL" })}>
                <span className="sr-only">Shotdok</span>
                <img
                  className="h-8 w-auto sm:h-10"
                  src={shotdokIcon}
                  alt="Shotdok Icon"
                />
              </Link>
              <LanguageSelector />
              {/* <div className="-mr-2 flex items-center md:hidden">
                <button
                  type="button"
                  className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500"
                  aria-expanded="false"
                >
                  <span className="sr-only">Menü öffnen</span>
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div> */}
            </div>
          </div>
          {/* <div className="hidden md:block md:ml-10 md:pr-4 md:space-x-8"> */}
          <div className="block md:ml-10 md:pr-4 md:space-x-8">
            <Link
              className="font-medium text-gray-500 hover:text-gray-900"
              to={intl.formatMessage({ id: "LINK_HOME_URL" })}
            >
              <FormattedMessage id="LINK_HOME_NAME" />
            </Link>

            {/* <a
              href="#"
              className="font-medium text-gray-500 hover:text-gray-900"
            >
              Features
            </a>

            <a
              href="#"
              className="font-medium text-gray-500 hover:text-gray-900"
            >
              Marketplace
            </a>

            <a
              href="#"
              className="font-medium text-gray-500 hover:text-gray-900"
            >
              Company
            </a>

            <a
              href="#"
              className="font-medium text-pink-600 hover:text-pink-500"
            >
              Log in
            </a> */}
          </div>
        </nav>
      </div>

      {/* <!--
              Mobile menu, show/hide based on menu open state.

              Entering: "duration-150 ease-out"
                From: "opacity-0 scale-95"
                To: "opacity-100 scale-100"
              Leaving: "duration-100 ease-in"
                From: "opacity-100 scale-100"
                To: "opacity-0 scale-95"
            --> */}
      {/* <div className="absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
        <div className="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div className="px-5 pt-4 flex items-center justify-between">
            <div>
              <img
                className="h-8 w-auto"
                src="https://tailwindui.com/img/logos/workflow-mark-pink-600.svg"
                alt=""
              />
            </div>
            <div className="-mr-2">
              <button
                type="button"
                className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500"
              >
                <span className="sr-only">Close main menu</span>
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a
              href="#"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
            >
              Product
            </a>

            <a
              href="#"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
            >
              Features
            </a>

            <a
              href="#"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
            >
              Marketplace
            </a>

            <a
              href="#"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
            >
              Company
            </a>
          </div>
          <a
            href="#"
            className="block w-full px-5 py-3 text-center font-medium text-pink-600 bg-gray-50 hover:bg-gray-100"
          >
            Log in
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default NavigationBar;
